import { createStyles } from "@material-ui/core";

export const styles = createStyles({
  listItem: {
    height: 40,
    marginTop: 7,
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeListItem: {
    width: 255,
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #0F76AF, #004B81)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
  nestedListItem: {
    height: 40,
    width: 242,
    marginTop: 7,
    marginLeft: 10,
    "&:hover": {
      borderRadius: 20,
    },
    "& svg": {
      color: "#C9C8C8",
    },
  },
  activeNestedListItem: {
    borderRadius: 20,
    backgroundImage: "linear-gradient(278deg, #4aa9d8, #1779c0)",
    color: "white",
    "& svg": {
      color: "white",
    },
  },
});
